import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgLaptopAnalyticsIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="laptop_analytics_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M46 31a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h6.586L33 32.586l-7.293-7.293a.999.999 0 0 0-1.414 0l-8 8a.999.999 0 1 0 1.414 1.414L25 27.414l7.293 7.293a.997.997 0 0 0 1.414 0L45 23.414V30a1 1 0 0 0 1 1z"
      />
      <path d="M10 14c0-1.103.897-2 2-2h40c1.103 0 2 .897 2 2v29h4V14c0-3.309-2.691-6-6-6H12c-3.309 0-6 2.691-6 6v29h4V14zM62 45H40v3H24v-3H2a1 1 0 0 0-1 1c0 4.962 4.037 9 9 9h44c4.963 0 9-4.038 9-9a1 1 0 0 0-1-1z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgLaptopAnalyticsStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgLaptopAnalyticsIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const LaptopAnalyticsIcon: any = SvgLaptopAnalyticsStyle;
export default LaptopAnalyticsIcon;
